import React from "react";
import { Zoom } from "react-reveal";
import Fade from "react-reveal/Fade";
import Jump from "react-reveal/Jump";
// import Logo from "../../assets/Action Voice_Final 400x100 Transparent-01.png";

const Navbar = () => {
  const onServiceClick = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView();
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light navbgColor sticky-top">
        <div className="container-fluid">
          <Jump right big cascade>
            <a className="navbar-brand" onClick={() => onServiceClick("Home")}>
              <img
                src={"images/logo.png"}
                alt="Company Logo"
                className="logoimg"
              />
            </a>
          </Jump>
          <button
            className="navbar-toggler custom-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            {/* <div className="d-flex"> */}
            <div className="navbar-nav ms-auto">
              <Zoom top big>
                <a
                  className="nav-link active spcIcon cursor-pointer"
                  aria-current="page"
                  onClick={() => onServiceClick("Home")}
                >
                  Home
                </a>
              </Zoom>
              <Zoom top big>
                <a
                  className="nav-link spcIcon cursor-pointer"
                  onClick={() => onServiceClick("About")}
                >
                  About Us
                </a>
              </Zoom>
              <Zoom top big>
                <a
                  className="nav-link spcIcon cursor-pointer"
                  onClick={() => onServiceClick("Team")}
                >
                  Team
                </a>
              </Zoom>
              <Zoom top big>
                <a
                  className="nav-link spcIcon cursor-pointer"
                  onClick={() => onServiceClick("Gallery")}
                >
                  Gallery
                </a>
              </Zoom>
              <Zoom top big>
                <a
                  className="nav-link spcIcon cursor-pointer"
                  onClick={() => onServiceClick("Project")}
                >
                  Projects
                </a>
              </Zoom>
              <Zoom top big>
                <a
                  className="nav-link spcIcon cursor-pointer"
                  onClick={() => onServiceClick("Client")}
                >
                  Client
                </a>
              </Zoom>
              <Zoom top big>
                <a
                  className="nav-link spcIcon cursor-pointer"
                  onClick={() => onServiceClick("Contact")}
                >
                  Contact Us
                </a>
              </Zoom>
              {/* </Fade> */}
            </div>
            {/* </div> */}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
